exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/robinson/search/components/search-robinson/search-robinson.component.scss
// module id = ../../../../../src/app/robinson/search/components/search-robinson/search-robinson.component.scss
// module chunks = main